<template>
    <form v-on:submit.prevent="updatePin" action="">
        <div class="row justify-content-center">
            <div class=col-12>
	            <div class="form-group" :class="{'form-group--error': $v.profile.current_pin.$error}">
		            <input
				            :placeholder="'OLD PIN' | trans"
				            readonly="readonly"
				            type="password"
				            v-model="profile.current_pin"
				            class="form-control"
				            id="current_pin"
				            :class="status($v.profile.current_pin)"
				            @click.prevent="showNumPad(1)">
		            <ul class="invalid-feedback list-unstyled" v-if="$v.profile.current_pin.$error">
			            <li v-if="!$v.profile.current_pin.required">
				            {{'This field is required' | trans}}
			            </li>
		            </ul>
		            <form-errors :field-name="'current_pin'" />
	            </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class=col-12>
	            <div class="form-group" :class="{'form-group--error': $v.profile.pin.$error}">
		            <input
				            :placeholder="'NEW PIN' | trans"
				            readonly="readonly"
				            type="password"
				            v-model="profile.pin"
				            class="form-control"
				            id="pin"
				            :class="status($v.profile.pin)"
				            @click.prevent="showNumPad(2)">
		            <ul class="invalid-feedback list-unstyled" v-if="$v.profile.pin.$error">
			            <li v-if="!$v.profile.pin.required">
				            {{'This field is required' | trans}}
			            </li>
			            <li v-if="!$v.profile.pin.minLength || !$v.profile.pin.maxLength">
				            {{'PIN length must be 4 characters' | trans}}
			            </li>
		            </ul>
		            <form-errors :field-name="'pin'" />
	            </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class=col-12>
	            <div class="form-group" :class="{'form-group--error': $v.profile.pin_confirmation.$error}">
		            <input
				            :placeholder="'CONFORM PIN' | trans"
				            readonly="readonly"
				            type="password"
				            v-model="profile.pin_confirmation"
				            class="form-control"
				            id="pin_confirmation"
				            :class="status($v.profile.pin_confirmation)"
				            @click.prevent="showNumPad(3)">
		            <ul class="invalid-feedback list-unstyled" v-if="$v.profile.pin_confirmation.$error">
			            <li v-if="!$v.profile.pin_confirmation.required">
				            {{'This field is required' | trans}}
			            </li>
			            <li v-if="!$v.profile.pin_confirmation.sameAs">
				            {{'Should be same as PIN' | trans}}
			            </li>
		            </ul>
		            <form-errors :field-name="'pin_confirmation'" />
	            </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12">
                <spinner-button :className="'btn btn-danger btn-block'" @click="updatePin" :is-pending="isPending">
                    {{'Save' | trans}}
                </spinner-button>
            </div>
        </div>
	    <!-- the modal -->
	    <b-modal v-model="pinModalShow" lazy centered hide-footer hide-header>
		    <password-group @change="emit('input', pin)" v-model="pin"
		                    :placeholder="'Enter Your Pin' | trans"
		                    keyboard="true"
		                    :reset="resetNumPad"
		    ></password-group>
		    <div class="mt-2">
		        <b-button class="btn-danger" @click="setPin">{{'Set' | trans}}</b-button>
		    </div>
	    </b-modal>
    </form>
</template>
<script>
	const { required, minLength, maxLength, sameAs } = require('vuelidate/lib/validators');
	import { validationMixin } from 'vuelidate';

    export default {
        props: ['route'],
	    mixins: [validationMixin],
        data() {
            return {
	            pinModalShow: false,
            	pin: '',
                isPending: false,
	            resetNumPad: false,
                profile: {
	                current_pin: '',
	                pin: '',
	                pin_confirmation: ''
                },
	            activeInput: null
            };
        },
        methods: {
            async updatePin() {
	            this.$v.$touch();
	            if (!this.$v.$invalid) {
		            this.isPending = true;
		            this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
		            await axios.post(this.route, this.profile)
			            .then(() => {
				            this.EventBus.$emit('event-success', Lang.get('Success'));
				            this.$emit("pinUpdated")
			            })
			            .finally(() => this.isPending = false);

	            }
            },
	        showNumPad(type) {
		        this.resetNumPad = true;
		        this.pinModalShow = true;
		        this.activeInput = type;
	        },
	        setPin() {
		        this.pinModalShow = false;
		        switch(this.activeInput) {
			        case 1:
			        	this.profile.current_pin = this.pin;
				        break;
			        case 2:
				        this.profile.pin = this.pin;
				        break;
			        case 3:
				        this.profile.pin_confirmation = this.pin;
				        break;
			        default:
				        break;
		        }
	        }
        },
	    validations() {
		    let v = {
			    profile: {
				    current_pin: {required},
				    pin: {
					    required,
					    minLength: minLength(4),
					    maxLength: maxLength(4)
				    },
				    pin_confirmation: {
					    required,
					    sameAs: sameAs('pin')
				    }
			    }
		    };
		    return v;
	    }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/update-pin.vue